export const TRT_STICKY_HEADER = 'TRT-STICKY-HEADER';
export const TRT_STICKY_HEADER_WRAPPER = 'TRT-STICKY-HEADER-WRAPPER';
export const TRT_CAROUSEL_BREAKING_NEWS = 'TRT-CAROUSEL-BREAKING-NEWS';
export const TRT_SECONDARY_MENU_HEADER = 'TRT-SECONDARY-MENU-HEADER';

export const TRT_CHANNEL_LOGO_CLASSNAME = 'trt-channel-logo-container';

export const TRT_CHANNEL_LOGO_MULTICOLOR_CLASSNAME =
  'trt-channel-logo-multicolor';

export const TRT_BREKINGNEWS_WRAPPER = 'TRT-BREKINGNEWS-WRAPPER';

export const TRT_TV_SCHEDULE_CURRENT_PROGRAM_ID =
  'TRT-TV-SCHEDULE-CURRENT-PROGRAM-ID';
